// IE 11 polyfills
import "core-js";
import "@babel/polyfill";
import "polyfill-array-includes";

import Vue from 'vue';
import App from './App.vue';
import VueRouter from 'vue-router';
import Vuelidate from 'vuelidate';
import VueMeta from 'vue-meta';
import axios from 'axios';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import VueAnalytics from 'vue-analytics';

import 'vue-material/dist/vue-material.min.css';
import './assets/scss/main.scss';

import Home from './pages/home.vue';
import MessageForm from './pages/message-form.vue';

import {
  MdApp,
  MdField,
  MdButton,
  MdContent,
  MdToolbar,
  MdEmptyState,
  MdProgress,
} from 'vue-material/dist/components';

Vue.use(MdApp);
Vue.use(MdField);
Vue.use(MdButton);
Vue.use(MdContent);
Vue.use(MdToolbar);
Vue.use(MdEmptyState);
Vue.use(MdProgress);

Vue.use(VueRouter);
Vue.use(Vuelidate);
Vue.use(VueMeta);
Vue.use(VueReCaptcha, { siteKey: '6LdKALkUAAAAAL8g5xW0-bYuosRkgEdqkMAUtIAZ' });

const routes = [
  {
    path: '/',
    name: 'notFound',
    component: Home,
  },
  {
    path: '/:siteKey',
    name: 'home',
    component: Home,
    props: route => ({ siteKey: route.params.siteKey }),
  },
  {
    path: '/:siteKey/:id',
    name: 'form',
    component: MessageForm,
    props: route => ({ siteKey: route.params.siteKey, id: route.params.id }),
  },
];
const router = new VueRouter({
  mode:'history',
  base: process.env.BASE_URL,
  routes, // short for `routes: routes`
});

Vue.use(VueAnalytics, { id: 'api-5615767647969318547-947291', router });

Vue.config.productionTip = false;

// Global axios Configuration
axios.defaults.headers.common = {
  'X-Diagnotes-ClientPlatform': 'web',
  Accept: 'application/json',
};

axios.interceptors.response.use(response => response, (error) => {
  if (typeof error.response === 'undefined') {
    return Promise.reject(error);
  }

  if (error.response.status === 401) {
    const path = window.location.pathname;
    window.location.href = `${window.location.origin}/user_sessions/new?previous_url=${path}`;
  }

  return Promise.reject(error);
});

Vue.prototype.$axios = axios;

new Vue({
  render: h => h(App),
  router,
}).$mount('#app');
